import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import cloudDownload from '../../../common/images/cloudDownload.png'
import { useStyles } from './SalesforceLoadingScreen.styles'

const SalesforceLoadingScreen: React.FC = () => {
  const { classes } = useStyles()

  return (
    <div className={classes.SFLoadingScreen}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          textAlign: 'center',
        }}
      >
        <img
          src={cloudDownload}
          data-testid="cloudDownload-logo"
          style={{ fontSize: 80, color: '#4db4f9', marginBottom: '20px' }}
        />

        <Typography variant="h5" gutterBottom>
          Your Salesforce AppExchange listing details are being fetched.
        </Typography>

        <Typography variant="body1" color="textSecondary">
          It may take a few minutes to fill common details, please wait..
        </Typography>

        <CircularProgress style={{ color: '#FFCC00', marginTop: '20px' }} />
      </Box>
    </div>
  )
}

export default SalesforceLoadingScreen
